import React from 'react'

import HELPTEXT from '../../../business-const/HelpText/HelpText'

import LABEL from '../../../business-const/Label/Label'

import MESSAGE from '../../../business-const/Message/Message'

import TAMMAX from '../../../business-rules/TamMax/TamMax'

import NUMMIN from '../../../business-rules/NumMinMax/NumMin'

import NUMMAX from '../../../business-rules/NumMinMax/NumMax'

import {
    GridContainer,
} from '../../../business-components/Grid/Grid'

import {
    TablePaginationPadrao,
    rowPertentePage,
    setPageInclusao,
    setPageExclusao,
} from '../../../business-components/Pagination/Pagination'

import {
    TextValidatorText,
    TextValidatorNumberRequired,
    TextValidatorValor,
    TextValidatorValorRequired,
    TextValidatorTextMultiline,
    TextValidatorDiaRequired,
    TextValidatorMesRequired,
    TextValidatorMesAnoRequired,
} from '../../../business-components/TextValidator/TextValidator'

import {
    TextFieldTextSelect,
    TextFieldNumberSelect,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    CheckboxPadrao
} from '../../../business-components/Checkbox/Checkbox'

import tipoProjetoVidaSonhoList from '../../../business-rules/List/tipoProjetoVidaSonhoList'

import tipoPeriodicidadeList from '../../../business-rules/List/tipoPeriodicidadeList'

import {
    IconButtonClearEntradaDados,
    IconButtonHelp,
} from '../../../business-components/IconButton/IconButton'

import {
    processaAlteracaoProjetoVidaSonhoFamiliar,
    processaAlteracaoProjetoVidaSonhoTipoProjetoVidaSonho,
    processaAlteracaoProjetoVidaSonhoValorAcumulacaoJaRealizado,
    processaAlteracaoProjetoVidaSonhoTracarMeta,
    processaAlteracaoProjetoVidaSonhoRecorrencia,
    processaAlteracaoProjetoVidaSonhoControlarAportes,
    dadosInvalidosLinhaProjetoVidaSonhoTracarMeta,
} from './ProjetoVidaSonhoServiceProjetoVidaSonho'



export const TablePaginationPadraoProjetoVidaSonho = ({ values, setFieldValue }) => {

    return (
        <TablePaginationPadrao
            setFieldValue={setFieldValue}
            list={values.projetoVidaSonhoPagination}
            nameRowsPerPage={'rowsPerPageProjetoVidaSonho'}
            namePage={'pageProjetoVidaSonho'}
            rowsPerPage={values.rowsPerPageProjetoVidaSonho}
            page={values.pageProjetoVidaSonho}
        />
    )
}

export const rowPertentePageProjetoVidaSonho = (values, indAux) => {
    
    return rowPertentePage(indAux, values.pageProjetoVidaSonho, values.rowsPerPageProjetoVidaSonho)
}

export const setPageInclusaoProjetoVidaSonho = (values, setFieldValue) => {

    return setPageInclusao(setFieldValue, 'pageProjetoVidaSonho', values.projetoVidaSonhoPagination, values.rowsPerPageProjetoVidaSonho)
}



export const Familiar = ({ values, item, ind, handleChange, expandiu }) => {

    return (
        <TextFieldNumberSelect
            name={`projetoVidaSonho[${ind}].familiar`}
            label={LABEL.familiar}
            value={item.familiar || ''}
            onChange={handleChange}
            list={values.totalProjetoVidaSonho}
            onBlur={processaAlteracaoProjetoVidaSonhoFamiliar(item)}
            disabled={expandiu}
        />
    )
}

export const TipoProjetoVidaSonho = ({ TextFieldNumberSelectTipoProjetoVidaSonho, values, item, ind, handleChange, expandiu }) => {

    return (
        <TextFieldNumberSelectTipoProjetoVidaSonho
            name={`projetoVidaSonho[${ind}].tipoProjetoVidaSonho`}
            placeholder={LABEL.tipoProjetoVidaSonho}
            value={item.tipoProjetoVidaSonho || ''}
            onChange={handleChange}
            list={tipoProjetoVidaSonhoList}
            onBlur={processaAlteracaoProjetoVidaSonhoTipoProjetoVidaSonho(item, values)}
            disabled={expandiu}
        />
    )
}

export const IconButtonClearEntradaDadosProjetoVidaSonho = ({ values, setFieldValue, ind, arrayHelpers, simplificado }) => {

    return (
        !simplificado
            ?
                <IconButtonClearEntradaDados
                    type="submit"
                    onClick={() => {
                        arrayHelpers.remove(ind)
                        setPageExclusao(setFieldValue, 'pageProjetoVidaSonho', values.projetoVidaSonhoPagination, values.rowsPerPageProjetoVidaSonho,
                            values.pageProjetoVidaSonho)
                    }}
                />
            :
                ''
    )
}

export const Valor = ({ values, item, ind, handleChange, expandiu }) => {

    return (
        <TextValidatorValorRequired
            name={`projetoVidaSonho[${ind}].valor`}
            label={LABEL.valor}
            value={item.valor || ''}
            onChange={handleChange}
            onBlur={
                processaAlteracaoProjetoVidaSonhoValorAcumulacaoJaRealizado(item, values)
            }
            disabled={expandiu}
        />
    )
}

export const ValorAcumulacaoJaRealizado = ({ values, item, ind, handleChange }) => {

    return (
        <TextValidatorValor
            name={`projetoVidaSonho[${ind}].valorAcumulacaoJaRealizado`}
            label={LABEL.valorAcumulacaoJaRealizado}
            value={item.valorAcumulacaoJaRealizado || ''}
            onChange={handleChange}
            onBlur={
                processaAlteracaoProjetoVidaSonhoValorAcumulacaoJaRealizado(item, values)
            }
        />
    )
}

export const IdadeRealizacao = ({ item, ind, handleChange, expandiu }) => {

    return (
        <TextValidatorNumberRequired
            name={`projetoVidaSonho[${ind}].idadeRealizacao`}
            label={LABEL.idadeRealizacao}
            value={item.idadeRealizacao === 0 ? 0 : item.idadeRealizacao || ''}
            onChange={handleChange}
            numMin={NUMMIN.idade}
            numMax={NUMMAX.idade}
            disabled={expandiu}
        />
    )
}

export const AnoRealizacao = ({ item, ind, handleChange, expandiu }) => {

    return (
        <TextValidatorNumberRequired
            name={`projetoVidaSonho[${ind}].anoRealizacao`}
            label={LABEL.anoRealizacao}
            value={item.anoRealizacao || ''}
            onChange={handleChange}
            numMin={NUMMIN.ano}
            numMax={NUMMAX.ano}
            disabled={expandiu}
        />
    )
}

export const HelpValorAcumulacaoJaRealizado = () => {

    return (
        <IconButtonHelp
            helpTitle={LABEL.valorAcumulacaoJaRealizado}
            helpText={HELPTEXT.valorAcumulacaoJaRealizado}
        />
    )
}

export const TracarMeta = ({ values, item, ind, handleChange }) => {

    return (
        <CheckboxPadrao
            name={`projetoVidaSonho[${ind}].tracarMeta`}
            label={LABEL.tracarMeta}
            checked={item.tracarMeta}
            onChange={handleChange}
            onBlur={
                processaAlteracaoProjetoVidaSonhoTracarMeta(item, values)
            }
        />
    )
}

export const HelpTracarMeta = () => {

    return (
        <IconButtonHelp
            helpTitle={LABEL.tracarMeta}
            helpText={HELPTEXT.tracarMeta}
        />
    )
}

export const MesAnoInicioAcumulacao = ({ item, ind, handleChange, expandiu }) => {

    return (
        <TextValidatorMesAnoRequired
            name={`projetoVidaSonho[${ind}].mesAnoInicioAcumulacao`}
            label={LABEL.mesAnoInicioAcumulacao}
            value={item.mesAnoInicioAcumulacao || ''}
            onChange={handleChange}
            disabled={expandiu}
        />
    )
}

export const MesAnoFimAcumulacao = ({ item, ind, handleChange, expandiu }) => {

    return (
        <TextValidatorMesAnoRequired
            name={`projetoVidaSonho[${ind}].mesAnoFimAcumulacao`}
            label={LABEL.mesAnoFimAcumulacao}
            value={item.mesAnoFimAcumulacao || ''}
            onChange={handleChange}
            disabled={expandiu}
        />
    )
}

export const MesRealizacao = ({ item, ind, handleChange, expandiu }) => {

    return (
        <TextValidatorMesRequired
            name={`projetoVidaSonho[${ind}].mesRealizacao`}
            label={LABEL.mesRealizacao}
            value={item.mesRealizacao || ''}
            onChange={handleChange}
            disabled={expandiu}
        />
    )
}


export const DadosInvalidosTracarMeta = ({ values, item }) => {

    return (
        dadosInvalidosLinhaProjetoVidaSonhoTracarMeta(values, item) && (
            <GridContainer>
                <h6
                    className='text-error ml-1 mt-1'
                >
                    {MESSAGE().dadosInvalidosTracarMeta}
                </h6>
            </GridContainer>
        )
    )
}

export const TipoPeriodicidadeAporte = ({ item, ind, handleChange }) => {

    return (
        <TextFieldTextSelect
            name={`projetoVidaSonho[${ind}].tipoPeriodicidadeAporte`}
            label={LABEL.tipoPeriodicidadeAporte}
            value={item.tipoPeriodicidadeAporte || ''}
            onChange={handleChange}
            list={tipoPeriodicidadeList(false, false, false)}
        />
    )
}

export const Recorrencia = ({ values, item, ind, handleChange }) => {

    return (
        <CheckboxPadrao
            name={`projetoVidaSonho[${ind}].recorrencia`}
            label={LABEL.recorrencia}
            checked={item.recorrencia}
            onChange={handleChange}
            onBlur={
                processaAlteracaoProjetoVidaSonhoRecorrencia(values, item)
            }
        />
    )
}

export const AnoLimiteRecorrencia = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorNumberRequired
            name={`projetoVidaSonho[${ind}].anoLimiteRecorrencia`}
            label={LABEL.anoLimiteRecorrencia}
            value={item.anoLimiteRecorrencia || ''}
            onChange={handleChange}
            numMin={NUMMIN.ano}
            numMax={NUMMAX.ano}
        />
    )
}

export const ControlarAportes = ({ item, ind, handleChange }) => {

    return (
        <CheckboxPadrao
            name={`projetoVidaSonho[${ind}].controlarAportes`}
            label={LABEL.controlarAportes}
            checked={item.controlarAportes}
            onChange={handleChange}
            onBlur={
                processaAlteracaoProjetoVidaSonhoControlarAportes(item)
            }
        />
    )
}

export const DiaAporte = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorDiaRequired
            name={`projetoVidaSonho[${ind}].diaAporte`}
            label={LABEL.diaAporte}
            value={item.diaAporte || ''}
            onChange={handleChange}
        />
    )
}

export const Descricao = ({ item, ind, handleChange, expandiu }) => {

    return (
        <TextValidatorText
            name={`projetoVidaSonho[${ind}].descricao`}
            label={LABEL.descricao}
            value={item.descricao || ''}
            onChange={handleChange}
            tamMax={TAMMAX.descricaoProjetoVidaSonho}
            notToUpperCase={true}
            disabled={expandiu}
        />
    )
}

export const HelpDescricaoProjetoVidaSonho = () => {

    return (
        <IconButtonHelp
            helpTitle={LABEL.descricao}
            helpText={HELPTEXT.descricaoProjetoVidaSonho}
        />
    )
}

export const Observacao = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorTextMultiline
            name={`projetoVidaSonho[${ind}].observacao`}
            label={LABEL.observacao}
            value={item.observacao || ''}
            onChange={handleChange}
            tamMax={TAMMAX.observacao}
        />
    )
}
